var _rect, _rect2, _rect3, _rect4, _path, _path2, _ellipse, _ellipse2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoOffersAvailable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 53,
    viewBox: "0 0 46 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.488,
    y: 2.82666,
    width: 10.7463,
    height: 6.66661,
    fill: "#76BC21"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8015,
    y: 0.82666,
    width: 16.1194,
    height: 2.66665,
    rx: 1.33332,
    fill: "#76BC21"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.67698,
    height: 4.01454,
    transform: "matrix(0.722302 0.691578 -0.700378 0.713772 39.324 10.1604)",
    fill: "#76BC21"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7.28549,
    height: 2.42824,
    rx: 1.21412,
    transform: "matrix(0.722302 0.691578 -0.700378 0.713772 39.1401 7.11475)",
    fill: "#76BC21"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8687 30.4935C43.8687 41.9888 34.4772 51.3267 22.8687 51.3267C11.2601 51.3267 1.86865 41.9888 1.86865 30.4935C1.86865 18.9982 11.2601 9.66034 22.8687 9.66034C34.4772 9.66034 43.8687 18.9982 43.8687 30.4935Z",
    stroke: "#76BC21",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7576 38.3804L27.1427 23.4993",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.8796,
    cy: 26.4582,
    rx: 3.40646,
    ry: 4.29849,
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.8576,
    cy: 34.5285,
    rx: 3.40646,
    ry: 4.29849,
    stroke: "#76BC21",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOffersAvailable);
export default __webpack_public_path__ + "static/media/noOffersAvailable.14b1d9d5630e7e062154c86f2e1e0ba9.svg";
export { ForwardRef as ReactComponent };